import {
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  BootstrapInput,
  HeaderTitle,
  formstyle,
} from "../../../component/component";
import { LoadingButton } from "@mui/lab";
import { useDropzone } from "react-dropzone";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../../config/firebase";
import CustomizedSnackbars from "../../alert";
import { addUsers } from "../../../config/services";
import { useSelector } from "react-redux";

export default function Identity() {
  const userInfos = useSelector((state) => state.useInfos);

  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const [values, setValues] = React.useState({
    id_type: "International passport",
  });

  const handleChange = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
    //console.log(e.target.value);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  var url = `${window.location.protocol}//${window.location.host}`;
  var encodedurl = btoa(url);

  return (
    <Container>
      <CustomizedSnackbars
        openSnackbar={openSnackbar}
        handleCloseSnackbar={handleCloseSnackbar}
        severity="success"
        message={
          "Your file has been uploaded successfully, your account will be verified onces it is reviewed and confirmed."
        }
      />
      <Card variant="outlined">
        <CardContent>
          <HeaderTitle
            title={"Identity verification"}
            subtitle={
              "Upload any clear photo or scanned image of your identity document"
            }
          />
          <div style={formstyle.section}>
            <FormControl variant="standard">
              <InputLabel shrink htmlFor="names-input">
                Select document type to upload
              </InputLabel>
              <BootstrapInput
                defaultValue={values.id_type}
                select
                id="address-input"
                placeholder="identity document type"
                name="id_type"
                required
                onChange={handleChange}
              >
                {[
                  "International passport",
                  "Drivers Licence",
                  "Voters card",
                ].map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </BootstrapInput>
            </FormControl>
          </div>

          <Button
            disableElevation
            disabled={userInfos.kyc_verified}
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              window.location.href = `https://imageuploads.web.app/${encodedurl}/${
                userInfos.id
              }`;
            }}
          >
            Upload {values.id_type}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
